import React from 'react'
import s from './HomeMainContent.less'
import Footer from '../footer/Footer'
import { AdDesktopBannerHP } from '../advertising/InlineDesktopAdBanner'
import GeoentitiesAtAddressPicker from '../address/GeoentitiesAtAddressPicker'
import CitiesToDiscover from './CitiesToDiscover'
import { PushSponsoBannerPE } from '../advertising/PushSponsoBanner'
import AutoPromoPE from '../autopromo/AutoPromoPE'
import AutoPromoGE from '../autopromo/AutoPromoGE'
import FavoritesPushHp from '../UserAccount/Favorites/FavoritesPushHp'

export default function HomeMainContent() {
  return (
    <>
      <div className={s.root}>
        <FavoritesPushHp />
        <AdDesktopBannerHP />
        <PushSponsoBannerPE />
        <AutoPromoPE />
        <AutoPromoGE className={s.autopromo} />
        <GeoentitiesAtAddressPicker
          title={
            <h2 className={s.geoentitiesAtAdressTitle}>
              Plus de <strong>5 millions de lieux et magasins</strong> à proximité
            </h2>
          }
        />
        <CitiesToDiscover />
      </div>
      <Footer />
    </>
  )
}
